import * as React from "react"
import {Typography} from "@mui/material";
import {CardSeeker, ImageSeeker} from "@ui-seeker/core";

import StandaloneStyles from "Theme/GlobalStyles";


export default function LoadingScreen() {
    return <>
        <StandaloneStyles />

         <CardSeeker
             title=""
             sx={{ width: "70vw", height: "60vh" }}
             contentProps={{  sx: { height: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5, p: 7 } }}
         >
             <Typography variant="h4">
                 Checking Your Credentials... Please Wait
             </Typography>

             <ImageSeeker
                 src="/images/loading_animation.gif"
             />
        </CardSeeker>
    </>
}